import { render, staticRenderFns } from "./Technologies.vue?vue&type=template&id=20b6a9c2&"
import script from "./Technologies.vue?vue&type=script&lang=js&"
export * from "./Technologies.vue?vue&type=script&lang=js&"
import style0 from "./Technologies.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports